import { render, staticRenderFns } from "./FaqInput.vue?vue&type=template&id=87170fea&"
import script from "./FaqInput.vue?vue&type=script&lang=js&"
export * from "./FaqInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports